import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __experimentalUseCustomUnits as useCustomUnits, __experimentalUnitControl as BaseUnitControl } from '@wordpress/components';
/**
 * Internal dependencies
 */

import useSetting from '../use-setting';
export default function UnitControl(_ref) {
  let {
    units: unitsProp,
    ...props
  } = _ref;
  const units = useCustomUnits({
    availableUnits: useSetting('spacing.units') || ['%', 'px', 'em', 'rem', 'vw'],
    units: unitsProp
  });
  return createElement(BaseUnitControl, _extends({
    units: units
  }, props));
}
//# sourceMappingURL=index.js.map